module.exports = __webpack_public_path__ + "img/24_8.c3696903.png";